<app-diagnostic-topbar (dateRangeSelected)="setDate($event)"></app-diagnostic-topbar>
<div class="fixed-height" id="user-chart">
  <div id="diagnostic-chart"></div>
</div>
